<template>
  <div :class="!this.$store.getters.iframeColidee ? 'bloc p-1' : 'p-1'">
    <div class="field">
      <label class="label">{{ $t("evenement.etat") }}</label>
      <div class="hr-grey" />
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.evenement.isLoading }"
      >
        <label class="radio">
          <div
            :style="
              isChecked_STATE
                ? 'background-color:green; padding:10px;color:white'
                : 'padding:10px;'
            "
          >
            <input
              type="radio"
              value="1"
              name="STATE"
              v-bind:checked="isChecked_STATE"
              @click="onFormChange"
              v-bind="{ disabled: this.$store.state.evenement.isLoading }"
            />
            {{ $t("evenement.etat_ouvert") }}
          </div>
        </label>
        <label class="radio">
          <div
            :style="
              !isChecked_STATE
                ? 'background-color:red; padding:10px;color:white'
                : 'padding:10px;'
            "
          >
            <input
              type="radio"
              value="0"
              name="STATE"
              v-bind:checked="!isChecked_STATE"
              @click="onFormChange"
              v-bind="{ disabled: this.$store.state.evenement.isLoading }"
            />
            {{ $t("evenement.etat_ferme") }}
          </div>
        </label>
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("evenement.name") }}*</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.evenement.isLoading }"
      >
        <input
          :value="evenement_name"
          name="NAME"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('evenement.name')"
          v-bind="{ disabled: this.$store.state.evenement.isLoading }"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("evenement.client") }}</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.evenement.isLoading }"
      >
        <input
          :value="evenement_client"
          name="CLIENT"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('evenement.client')"
          v-bind="{ disabled: this.$store.state.evenement.isLoading }"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("evenement.evenement") }}</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.evenement.isLoading }"
      >
        <input
          :value="evenement_evenement"
          name="EVENEMENT"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('evenement.evenement')"
          v-bind="{ disabled: this.$store.state.evenement.isLoading }"
        />
      </div>
    </div>

    <!-- Champ Open et close -->
    <div style="margin-bottom:10px;">
      <label class="label">{{ $t("evenement.openAt") }}</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.evenement.isLoading }"
      >
        <b-datepicker
          :max-date="modelCloseAt"
          :locale="$store.state.langage.langue"
          :mobile-modal="false"
          v-model="modelOpenAt"
          :placeholder="$t('evenement.openAt')"
          trap-focus
          editable
          :first-day-of-week="0"
        ></b-datepicker>
      </div>
      <label style="margin-top:10px;" class="label">{{
        $t("evenement.closeAt")
      }}</label>
      <b-datepicker
        :min-date="modelOpenAt"
        :locale="$store.state.langage.langue"
        :mobile-modal="false"
        v-model="modelCloseAt"
        :placeholder="$t('evenement.closeAt')"
        expanded
        editable
        :first-day-of-week="0"
      ></b-datepicker>
      <div
        v-if="!isLoading && $store.getters.open_at < new Date()"
        style="margin-top:5px;"
      >
        <b-switch
          style="vertical-align:middle;"
          v-model="closeMeeting"
          type="is-warning"
        /><span style="margin-left:-10px;font-size:12px;">{{
          $t("evenement.close")
        }}</span>
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("evenement.background") }}</label>
      <div
        class="input"
        style="display:flex"
        v-if="!this.$store.state.evenement.has_background && !this.file"
      >
        <b-upload
          style="margin-left:-8px;"
          accept="image/png, image/gif, image/jpeg, video/mp4"
          v-model="file"
          @input="checkFileSize()"
        >
          <p class="file-label">
            <img
              style="margin-left:5px;margin-right:10px;width:18px; height:18px;"
              src="~@/assets/img/icons/add_photo.png"
              alt="add-photo"
            /><span>{{ $t("evenement.file") }}</span>
          </p>
        </b-upload>
      </div>
      <div
        style="font-size:12px;"
        v-if="this.$store.state.evenement.has_background || this.file"
      >
        <b-icon pack="fas" icon="check-square" size="is-small"></b-icon>
        {{ $t("evenement.file_ok") }}
        <span
          style="margin-left:55px;font-size:16px;cursor:pointer;"
          @click="removeFile()"
        >
          <b-tooltip
            position="is-left"
            :label="this.$t('evenement.deleted-image')"
          >
            <b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon>
          </b-tooltip>
        </span>
      </div>

      <img
        style="width:250px"
        v-if="this.$store.state.evenement.has_background"
        :src="this.url_textit + this.$store.state.evenement.has_background"
      />
      <div style="width:250px;" id="preview">
        <img v-if="url" :src="url" />
      </div>
    </div>
    <div>
      <div style="right:0px;">
        <div class="has-text-right">
          <div>
            <button
              class="button is-primary"
              @click="SubmitForm()"
              v-bind="{ disabled: this.$store.state.evenement.isLoading }"
            >
              {{ $t("button.sauvegarder") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Parameters",
  data() {
    return {
      file: null,
      url_textit: process.env.URL_MEDIA,
      query: "",
      pending: false,
      erreur_email: false,
      errors: [],
      data: [],
      tags: [],
      filteredTags: [],
      shares: [],
      selectedCountryFr: true,
      selectedCountryEn: false,
      selectedCountryEs: false,
      selectedCountryDe: false,
      showWarningTranslation: false,
      url: ""
    };
  },
  watch: {
    evenement_id() {
      this.getShares(this.evenement_id);
    }
  },
  computed: {
    ...mapGetters([
      "isLoading",
      "evenements",
      "evenement_name",
      "evenement_id",
      "evenement_evenement",
      "evenement_client",
      "evenement_state"
    ]),
    modelOpenAt: {
      get: function() {
        return this.$store.getters.open_at !== null
          ? this.$store.getters.open_at
          : null;
      },
      set: function(newValue) {
        this.$store.commit("SET_OPEN_AT", newValue);
      }
    },
    modelCloseAt: {
      get: function() {
        return this.$store.getters.close_at !== null
          ? this.$store.getters.close_at
          : null;
      },
      set: function(newValue) {
        this.$store.commit("SET_CLOSE_EVENEMENT", 0);
        this.$store.commit("SET_CLOSE_AT", newValue);
      }
    },
    closeMeeting: {
      get: function() {
        if (this.$store.getters.getCloseMeeting === 1) return true;
        else return false;
      },
      set: function(newValue) {
                 if (newValue === true) {
          this.$store.commit("SET_CLOSE_EVENEMENT", 1);
          this.$store.commit("SET_CLOSE_AT", new Date());
        }
        else {
          this.$store.commit("SET_CLOSE_EVENEMENT",0);
          this.$store.commit("SET_CLOSE_AT", null);
        }

      }
    },
    showResultsClient: {
      get: function() {
        if (this.$store.getters.showResultsClient === 1) return true;
        else return false;
      },
      set: function(newValue) {
        if (newValue === true) {
          this.$store.commit("SHOW_RESULTS_CLIENT", 1);
        } else {
          this.$store.commit("SHOW_RESULTS_CLIENT", 0);
        }
      }
    },
    isChecked_STATE() {
      if (this.$store.state.evenement.fields.state == 1) {
        return true;
      } else {
        return false;
      }
    },
    isChecked_TYPE() {
      if (this.$store.state.evenement.fields.type == "moderee") {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    evenements() {
      this.loading = false;
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        cardList: true,
        parameters: false
      });
    }
  },
  updated() {
    let message = {
      task: "updateHeight",
      height: document.body.scrollHeight
    };
    window.top.postMessage(message, "*");
  },
  methods: {
    checkFileSize() {
      if (this.file && this.file.size > 6000000) {
        this.file = null;
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.fichier_trop_lourd")
        });
      }
      this.url = URL.createObjectURL(this.file);
    },
    removeFile() {
      this.url = "";
      this.$store.commit(`UPDATE_HAS_BACKGROUND`, null);
      this.file = null;
    },
    SubmitForm(evt) {
      this.loading = true;
      if (this.$store.state.evenement.isEditing) {
        this.$store.dispatch("update_evenement", this.file);
      } else {
        this.$store.dispatch("create_new_evenement", this.file);
      }
      this.file = null;
    },
    onFormChange(evt) {
      this.$store.commit(
        `UPDATE_EVENEMENT_${evt.target.name}`,
        evt.target.value
      );
    }
  }
};
</script>
<style scoped>
.input {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.input::placeholder {
  color: grey;
}
label {
  font-size: 12px;
}
.flag {
  opacity: 0.2;
  cursor: pointer;
}
.selected-flag {
  opacity: 1;
  cursor: pointer;
}
.button {
  border-radius: 0px;
  font-size: 12px;
  color: white;
}
.column {
  padding-bottom: 0px !important;
}
.textarea {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.textarea::placeholder {
  color: grey;
}
.p-1 {
  padding: 10px;
}
.hr-grey {
  height: 1px;
  width: 100%;
  background: grey;
}
.texte_petit {
  font-size: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/event/Parameters.vue